export const role1 = "Admin";
export const role2 = "DealerUser";
export const role3 = "Staff";
